"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Status = function Status(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M8 19.5H16C16.0657 19.5 16.1307 19.4871 16.1914 19.462C16.2521 19.4369 16.3072 19.4001 16.3537 19.3537C16.4001 19.3072 16.4369 19.2521 16.462 19.1914C16.4871 19.1307 16.5 19.0657 16.5 19V5C16.5 4.86739 16.4473 4.74021 16.3536 4.64645C16.2598 4.55268 16.1326 4.5 16 4.5H8C7.86739 4.5 7.74021 4.55268 7.64645 4.64645C7.55268 4.74021 7.5 4.86739 7.5 5V19C7.5 19.1326 7.55268 19.2598 7.64645 19.3536C7.74021 19.4473 7.86739 19.5 8 19.5ZM12 5.5C12.3956 5.5 12.7822 5.6173 13.1111 5.83706C13.44 6.05682 13.6964 6.36918 13.8478 6.73463C13.9991 7.10009 14.0387 7.50222 13.9616 7.89018C13.8844 8.27814 13.6939 8.63451 13.4142 8.91421C13.1345 9.19392 12.7781 9.3844 12.3902 9.46157C12.0022 9.53874 11.6001 9.49913 11.2346 9.34776C10.8692 9.19638 10.5568 8.94004 10.3371 8.61114C10.1173 8.28224 10 7.89556 10 7.5C10 6.96957 10.2107 6.46086 10.5858 6.08579C10.9609 5.71071 11.4696 5.5 12 5.5ZM12 10C12.3956 10 12.7822 10.1173 13.1111 10.3371C13.44 10.5568 13.6964 10.8692 13.8478 11.2346C13.9991 11.6001 14.0387 12.0022 13.9616 12.3902C13.8844 12.7781 13.6939 13.1345 13.4142 13.4142C13.1345 13.6939 12.7781 13.8844 12.3902 13.9616C12.0022 14.0387 11.6001 13.9991 11.2346 13.8478C10.8692 13.6964 10.5568 13.44 10.3371 13.1111C10.1173 12.7822 10 12.3956 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 18.5C13.1046 18.5 14 17.6046 14 16.5C14 15.3954 13.1046 14.5 12 14.5C10.8954 14.5 10 15.3954 10 16.5C10 17.6046 10.8954 18.5 12 18.5Z",
    fill: props.foregroundColor
  }));
};

Status.defaultProps = {
  altText: "Status",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Status.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Status;
exports.default = _default;